import SurveyView from "./SurveyView"
export default SurveyView
